import React from "react";
import Button from "../Button";
import { FullRow } from "./FullRow";
import { post } from "../../lib/Fetching";
import PriceInput from "./PriceInput";
import { SSL_OP_NO_QUERY_MTU } from "constants";

export default class GroupPriceSettings extends React.Component {
  constructor(props) {
    super(props);
    const { quotable } = props;
    this.state = {
      quote_as_group: quotable.quote_as_group,
      sum_prices: quotable.sum_prices
    };
  }

  save = () => {
    const {
      quotable: { quote_group_id },
      attempt_id,
      onUpdated
    } = this.props;
    const { quote_as_group, sum_prices } = this.state;
    post("/quote_groups/update_pricing_settings.json", {
      attempt_id,
      quote_group_id,
      quote_as_group,
      sum_prices
    })
      .then(onUpdated)
      .catch(e => alert("Could not update pricing settings: " + e.message));
  };

  changeQuotableStatus = e => {
    this.setState({ quote_as_group: e.target.checked });
  };

  changePricingMethod = sum_prices => {
    this.setState({ sum_prices });
  };

  haveSettingsChanged = () => {
    const { quotable } = this.props;
    const { quote_as_group, sum_prices } = this.state;
    return quotable.quote_as_group !== quote_as_group || quotable.sum_prices !== sum_prices;
  };

  render() {
    const {
      quotable: { within_quotable_group, can_change_pricing_method }
    } = this.props;
    const { onCancel } = this.props;
    const { quote_as_group, sum_prices } = this.state;
    return (
      <div
        className="pull-right"
        style={{
          width: 480,
          marginBottom: 20,
          padding: 20,
          backgroundColor: "#FAFAFA",
          border: "1px solid #EEE",
          borderTop: 0,
          borderRight: 0
        }}
      >
        <div className="row">
          {!within_quotable_group && (
            <div className="col-md-7">
              <input
                type="checkbox"
                checked={quote_as_group}
                onChange={this.changeQuotableStatus}
              />&nbsp; Set Group Price?
              <span className="help-block small">
                Unticking this will remove any price associated to the group and will allow its
                constituents to be priced individually
              </span>
            </div>
          )}
          {can_change_pricing_method &&
            (within_quotable_group || (!within_quotable_group && quote_as_group)) && (
              <div className="col-md-5">
                <input
                  onChange={() => this.changePricingMethod(true)}
                  type="radio"
                  checked={sum_prices}
                />&nbsp; Sum group items?
                <br />
                <input
                  onChange={() => this.changePricingMethod(false)}
                  type="radio"
                  checked={!sum_prices}
                />&nbsp; Fixed Price?
              </div>
            )}
        </div>
        <div className="row" style={{ marginTop: 10 }}>
          <div className="col-md-12 text-center">
            <Button
              small
              title="Save"
              onClick={this.save}
              primary
              disabled={!this.haveSettingsChanged()}
            />
            &nbsp;&nbsp;&nbsp;
            <Button title="Cancel" small onClick={onCancel} />
          </div>
        </div>
      </div>
    );
  }
}
